/*
 * The Features Module. Should contain all Modules for different app features
 * <p>
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2020 Gallagher Bassett Services, Inc.
 *
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoginModule } from './login/login.module';
import { DirectivesModule } from 'app/shared/directives/directives.module';
import {
  BodyComponent,
  FooterComponent,
  HeaderComponent
} from 'app/features/layout';
import { HomeModule } from 'app/features/home/home.module';
import { ComponentsModule } from 'app/shared/components/components.module';
import { ErrorModule } from './error/error.module';
import { UserMenuComponent } from './layout/header/user-menu/user-menu.component';
import { PingPreauthComponent } from './ping-preauth/ping-preauth.component';
import { SelectClientDialogComponent } from './layout/header/select-client-dialog/select-client-dialog.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    BodyComponent,
    HeaderComponent,
    FooterComponent,
    UserMenuComponent,
    PingPreauthComponent,
    SelectClientDialogComponent,
  ],
  imports: [
    CommonModule,
    ComponentsModule,
    RouterModule,
    NgbModule,
    LoginModule,
    DirectivesModule,
    ComponentsModule,
    ErrorModule,
    FormsModule
  ],
  exports: [
    BodyComponent,
    HeaderComponent,
    FooterComponent,
    UserMenuComponent
  ],
})
export class FeaturesModule {}
